import { render, staticRenderFns } from "./product-price-setting-table.vue?vue&type=template&id=a267e3e8&"
import script from "./product-price-setting-table.vue?vue&type=script&lang=ts&"
export * from "./product-price-setting-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports